/**
 * age-top-kv.js
 */

document.addEventListener('DOMContentLoaded', function() {
  // ヘッダーの要素を取得
  var header = document.querySelector('.theme__header');

  // ヘッダーの高さを取得
  var headerHeight = header.offsetHeight;

  // .sec-kvの要素を取得
  var secKv = document.querySelector('.sec-kv');

  // .sec-kvの高さを指定
  secKv.style.height = 'calc(100vh - ' + ( headerHeight - 3 ) + 'px)';
});
